import React from "react";

/**
 * Render the enabled product's brand on shared authentication surfaces.
 *
 * @example
 * <AuthBrand imageSrc="/logo.svg" alt="Task Mantis" className="signin-page__brand" />
 */
const AuthBrand = ({ imageSrc, alt, className = "" }) => (
  <img
    src={imageSrc}
    alt={alt}
    className={["task-mantis-auth-brand", className].filter(Boolean).join(" ")}
  />
);

export default AuthBrand;
